import React from 'react'
import { Link } from 'react-router-dom'

export const TabSystem: React.FC = () => {
    return (
        <div className="flex flex-col md:grid md:grid-cols-2 md:auto-rows-fr gap-4">
            <div className="card_item card_item_dark">
                <h2>NOXSYS</h2>
                <div>
                    Полная автоматизация процесса организации и управления
                    закупками:
                    <ul>
                        <li>Планирование закупок</li>
                        <li>Управление закупками</li>
                        <li>Сопровождение договоров</li>
                        <li>Контроль за исполнением договоров</li>
                    </ul>
                </div>
            </div>
            <div className="card_item card_item_dark relative">
                <h2>Для компании любого масштаба</h2>
                <p>
                    Для Заказчиков, организующих свою деятельность по закупкам в
                    соответствии с 223-ФЗ
                </p>
                <div className="absolute bottom-0 md:bottom-4 right-0 text-[#407bff] text-4xl md:text-8xl font-bold">
                    223-ФЗ
                </div>
            </div>
            <div className="card_item card_item_dark">
                <h2>Российское программное обеспечение</h2>
                <div>
                    <ul>
                        <li>
                            Государственная регистрация программы для ЭВМ
                            <br />
                            <Link to="/" className="text-[#407bff]">
                                Номер регистрации № 2024683593
                            </Link>
                        </li>
                        <li>
                            В реестре Российского программного обеспечения
                            <br />
                            <Link to="/" className="text-[#407bff]">
                                Реестровая запись № 29258
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="card_item card_item_dark !bg-[#407bff] flex flex-col">
                <h2>Протестируй систему</h2>
                <p className="flex-grow">
                    Оставьте заявку и наш менеджер свяжется с вами и подскажет,
                    как система NOXSYS поможет решить ваши задачи
                </p>
                <div className="mt-4 md:mt-0">
                    <Link
                        to="/"
                        className="rounded-full px-6 py-2 text-[#407bff] bg-white"
                    >
                        Оставить заявку
                    </Link>
                </div>
            </div>
        </div>
    )
}
